import type { AssignToUsersState } from "../types/state";

const initialAssignToUsersState: AssignToUsersState = {
    areUsersBeingFetched: false,
    isAssignInProgress: false,
    isShowAssignToUserModal: false,
    users: [],
};

export default initialAssignToUsersState;
